import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './styles/App.css';

import HeaderTabComponent from './components/HeaderTabComponent';
import AdminDashboard from './components/AdminDashboard';
import ApplicantDashboard from './components/ApplicantDashboard';
import CallCenter from './components/CallCenter';
import HomePage from './components/HomePage';
import RegistrationForm from './components/RegistrationForm';

import FooterTabComponent from './components/FooterTabComponent';
import RegistrationExploration from './components/RegistrationExploration'; 
import RegistrationGNZ from './components/RegistrationGNZ';

import './styles/RegistrationExploration.css';
import RegistrationProductionlessMMTOE from './components/RegistrationProductionlessMMTOE';
import RegistrationProductionmoreMMTOE from './components/RegistrationProductionmoreMMTOE';
import RegistrationGH from './components/RegistrationGH';
import RegistrationDigital from './components/RegistrationDigital';
import RegistrationOverseas from './components/RegistrationOverseas';
import RegistrationSP from './components/RegistrationSP';
import RegistrationPipeline from './components/RegistrationPipeline';
import RegistrationOM from './components/RegistrationOM';
import RegistrationHRM from './components/RegistrationHRM';
import RegistrationRefinery from './components/RegistrationRefinery';
import RegistrationCBG from './components/RegistrationCBG';
import RegistrationBMP from './components/RegistrationBMP';
import RegistrationInnovator from './components/RegistrationInnovator';
import RegistrationWE from './components/RegistrationWE';
import RegistrationYM from './components/RegistrationYM';
import RegistrationYF from './components/RegistrationYF';
import RegistrationCGD from './components/RegistrationCGD';
import GHscoretable from './components/Tables/GHscoretable';
import CBGscoretable from './components/Tables/CBGscoretable';
import GNZscoretable from './components/Tables/GNZscoretable';
import Overseasscoretable from './components/Tables/Overseasscoretable';
import HRMscoretable from './components/Tables/HRMscoretable';
import ExcelHRM from './components/Excel/ExcelHRM';
import ExcelGNZ from './components/Excel/ExcelGNZ';
import ExcelRefinery from './components/Excel/ExcelRefinery';
import ExcelProdless from './components/Excel/ExcelProductionLess';
import ExcelProdmore from './components/Excel/ExcelProductionMore';
import ExcelDigital from './components/Excel/ExcelDigital';
import ExcelExploration from './components/Excel/ExcelExploration';
import ExcelOM from './components/Excel/ExcelOM';
import ExcelPipeline from './components/Excel/ExcelPipeline';
import ExcelSP from './components/Excel/ExcelSP';
import ExcelCGD from './components/Excel/ExcelCGD';
import ExcelGH from './components/Excel/ExcelGH';
import ExcelCBG from './components/Excel/ExcelCBG';
import ExcelBMP from './components/Excel/ExcelBMP';
import ExcelOverseas from './components/Excel/ExcelOverseas';
import Thankyou from './components/Thankyou';
import {downloadFile} from './common';

function AppContent() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState('user');
  const location = useLocation();
  const state = location.state || {};

  const formRoutes = [
    '/RegistrationForm',
    '/RegistrationExploration',
    '/RegistrationProduction',
    '/RefineryRegistration',
    '/RegistrationGNZ',
    "/RegistrationDigital",
  ];

  const showSidebar = !formRoutes.includes(location.pathname);


  useEffect(() => {
    if(!isLoggedIn){
      let userData = sessionStorage.getItem('user_info');
      if(userData){
        setIsLoggedIn(!isLoggedIn);
      }
    }

  }, [])

  const handleLogin = (role) => {
    setIsLoggedIn(true);
    setUserRole(role);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserRole('user');
  };

  const handleLoginClick = (type, postLoginAction) => {
    console.log(`Login clicked for ${type}`);
  };

  const handleRegisterClick = (type, postRegisterAction) => {
    console.log(`Register clicked for ${type}`);
  };

  return (
    <div className="app-container">
      <HeaderTabComponent />
      <div className="layout-container">
        <div className="mainn-container">
          <Routes>
            <Route
              path="/"
              element={
                <HomePage
                  isLoggedIn={isLoggedIn}
                  userRole={userRole}
                  onLogin={handleLogin}
                  onLogout={handleLogout}
                  onLoginClick={handleLoginClick}
                  onRegisterClick={handleRegisterClick}
                />
              }
            />
            <Route path="/guidelines" element={<div className="page-title">Guidelines Content</div>} />
            <Route path="/faqs" element={<div className="page-title">FAQs Content</div>} />
            <Route path="/contact" element={<CallCenter />} />
            <Route
              path="/applicant-dashboard"
              element={isLoggedIn && userRole !== 'admin' ? <ApplicantDashboard /> : <div>Access denied for admin</div>}
            />
            <Route
              path="/admin"
              element={isLoggedIn ? <AdminDashboard /> : <div>Access denied</div>}
            />
            <Route
              path="/RegistrationForm"
              element={isLoggedIn ? <RegistrationForm /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationExploration"
              element={isLoggedIn ? <RegistrationExploration /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationProductionlessMMTOE"
              element={isLoggedIn ? <RegistrationProductionlessMMTOE /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationProductionmoreMMTOE"
              element={isLoggedIn ? <RegistrationProductionmoreMMTOE /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationGH"
              element={isLoggedIn ? <RegistrationGH /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationGNZ"
              element={isLoggedIn ? <RegistrationGNZ /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationDigital"
              element={isLoggedIn ? <RegistrationDigital /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationOverseas"
              element={isLoggedIn ? <RegistrationOverseas /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationSP"
              element={isLoggedIn ? <RegistrationSP /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationPipeline"
              element={isLoggedIn ? <RegistrationPipeline /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationOM"
              element={isLoggedIn ? <RegistrationOM /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationHRM"
              element={isLoggedIn ? <RegistrationHRM /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationCBG"
              element={isLoggedIn ? <RegistrationCBG /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationRefinery"
              element={isLoggedIn ? <RegistrationRefinery /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationBMP"
              element={isLoggedIn ? <RegistrationBMP /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationInnovator"
              element={isLoggedIn ? <RegistrationInnovator /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationWE"
              element={isLoggedIn ? <RegistrationWE /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationYM"
              element={isLoggedIn ? <RegistrationYM /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationYF"
              element={isLoggedIn ? <RegistrationYF /> : <Navigate to="/" replace />}
            />
            <Route
              path="/RegistrationCGD"
              element={isLoggedIn ? <RegistrationCGD /> : <Navigate to="/" replace />}
            />
            <Route path="/" element={<Navigate to="/" replace />} />
            <Route path="/GHscoretable" element={<GHscoretable />} />
            <Route path="/CBGscoretable" element={<CBGscoretable />} />
            <Route path="/GNZscoretable" element={<GNZscoretable />} />
            <Route path="/Overseasscoretable" element={<Overseasscoretable />} />
            <Route path="/HRMscoretable" element={<HRMscoretable />} />
            {/* <Route path="/ExcelModifier" element={<ExcelModifier />} /> */}
            <Route path="/ExcelGNZ" element={<ExcelGNZ />} />
            <Route path="/ExcelRefinery" element={<ExcelRefinery />} />
            <Route path="/ExcelProdless" element={<ExcelProdless />} />
            <Route path="/ExcelProdmore" element={<ExcelProdmore />} />
            <Route path="/ExcelDigital" element={<ExcelDigital />} />
            <Route path="/ExcelHRM" element={<ExcelDigital />} />
            <Route path="/ExcelExploration" element={<ExcelExploration />} />
            <Route path="/ExcelOM" element={<ExcelOM />} />
            <Route path="/ExcelOverseas" element={<ExcelOverseas />} />
            <Route path="/ExcelPipeline" element={<ExcelPipeline />} />
            <Route path="/ExcelSP" element={<ExcelSP />} />
            <Route path="/ExcelCGD" element={<ExcelCGD />} />
            <Route path="/ExcelGH" element={<ExcelGH />} />
            <Route path="/ExcelCBG" element={<ExcelCBG />} />
            <Route path="/ExcelBMP" element={<ExcelBMP />} />
            <Route path="/Thankyou" element={<Thankyou />} />
          </Routes>
        </div>
      </div>
      <FooterTabComponent />
    </div>
  );
}

function App() {
  return (
    <Router 
     basename='/fipiawards'
    >
      <AppContent />
    </Router>
  );
}

export default App;